import { Box, LinearProgress } from '@mui/material';
import { FC } from 'react';

/**
 * A progress bar that reserves its own height when idle, so content below it does not jump as a
 * search starts and finishes. Height is a prop because callers sit in layouts of different density.
 */
export const LoadingBarOrEmptySpace: FC<{ loading: boolean; height?: number | string }> = ({
  loading,
  height = '2px',
}) => (loading ? <LinearProgress sx={{ height }} /> : <Box sx={{ height }} />);
